import { Outlet } from "@tanstack/react-router"
import { ButtonLink } from "design-system/atoms/Button"
import { BadgePingText } from "design-system/molecules/BadgePingText"
import { Card, CardDescription, CardHeader, CardTitle } from "design-system/molecules/Card"
import { Section } from "design-system/molecules/Section"
import { Pencil } from "lucide-react"
import { useReverIntegrationQuery } from "modules/settings/hooks/rever/useReverIntegrationQuery"
import { useTranslation } from "react-i18next"
import { CheckReturn } from "./components/checkReturn"

export const ReverConfiguration = () => {
  const { t } = useTranslation()
  const { data } = useReverIntegrationQuery()
  const hasConfiguration = data?.apiKey
  const disabledReason = t("settings.integrations.disabledRequiresConfiguration")

  return (
    <>
      <div className="flex flex-col gap-8">
        <Card>
          <CardHeader className="flex flex-row gap-4 p-4">
            <div className="grow flex flex-col gap-1">
              <CardTitle>{t("settings.integrations.rever.integrationCard.title")}</CardTitle>
              <CardDescription>
                {hasConfiguration
                  ? t("settings.integrations.rever.integrationCard.descriptionDone")
                  : t("settings.integrations.rever.integrationCard.descriptionPending")}
              </CardDescription>
            </div>
            <div className="flex items-center">
              {hasConfiguration ? (
                <div className="flex gap-2">
                  <BadgePingText
                    color={"success"}
                    text={t("settings.integrations.rever.integrationCard.connected")}
                  />
                  <ButtonLink
                    variant={"ghost"}
                    size="icon"
                    to="/settings/integrations/rever/connect"
                  >
                    <Pencil />
                  </ButtonLink>
                </div>
              ) : (
                <ButtonLink to={"/settings/integrations/rever/connect"}>
                  {t("settings.integrations.rever.integrationCard.configButton")}
                </ButtonLink>
              )}
            </div>
          </CardHeader>
        </Card>
        <Section title={t("settings.integrations.rever.tools")}>
          <div className="grid lg:grid-cols-2 xl:grid-cols-3 gap-4">
            <CheckReturn isDisabled={!hasConfiguration} disabledReason={disabledReason} />
          </div>
        </Section>
      </div>
      <Outlet />
    </>
  )
}
